<template>
  <el-dialog
    v-dialogDrag
    :title="titleType + '实施区域'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    class="small-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="选择场景" prop="sceneId">
        <el-select
          v-model="formData.sceneId"
          placeholder="请选择场景"
          filterable
          clearable
          :disabled="isCheck"
        >
          <el-option
            v-for="item in sceneList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域编码" prop="code">
        <el-input
          v-model="formData.code"
          maxlength="50"
          show-word-limit
          clearable
          :disabled="isCheck"
        ></el-input>
      </el-form-item>
      <el-form-item label="区域名称" prop="name">
        <el-input v-model="formData.name" clearable :disabled="isCheck"></el-input>
      </el-form-item>
      <el-form-item label="区域高度" prop="height">
        <el-input v-model="formData.height" clearable :disabled="isCheck">
          <template slot="append">米</template>
        </el-input>
      </el-form-item>
      <el-form-item label="区域偏移X" prop="x">
        <el-input v-model="formData.x" clearable :disabled="isCheck">
          <template slot="append">米</template>
        </el-input>
      </el-form-item>
      <el-form-item label="区域偏移Y" prop="y">
        <el-input v-model="formData.y" clearable :disabled="isCheck">
          <template slot="append">米</template>
        </el-input>
      </el-form-item>
      <el-form-item label="偏移角度" prop="angle">
        <el-input v-model="formData.angle" clearable :disabled="isCheck">
          <template slot="append">度</template>
        </el-input>
        <el-tooltip effect="dark" content="正数为顺时针旋转，负数为逆时针旋转" placement="top">
          <span class="iconfont icon-line-question ml-10px text-blue-500 cursor-pointer"></span>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="X轴反转">
        <el-switch
          v-model="formData.xReverse"
          :active-value="-1"
          :inactive-value="1"
          :disabled="isCheck"
        ></el-switch>
      </el-form-item>
      <el-form-item label="Y轴反转">
        <el-switch
          v-model="formData.yReverse"
          :active-value="-1"
          :inactive-value="1"
          :disabled="isCheck"
        ></el-switch>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          v-model="formData.remark"
          :autosize="{ minRows: 2, maxRows: 6 }"
          :disabled="isCheck"
          placeholder=""
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" v-if="!isCheck">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ImplementAreaApi } from '@wiz-api/personnel-position'
import { isEmpty, cloneDeep } from 'lodash'

const implementAreaApi = new ImplementAreaApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    sceneList: {
      type: Array,
      default: () => {
        return []
      },
    },
    operateType: {
      type: String,
      default: 'create',
    },
    operateProps: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    if (!isEmpty(this.operateProps)) {
      this.formData = cloneDeep(this.operateProps)
      this.$set(this.formData, 'xReverse', this.operateProps.extraProperties?.xReverse || 1)
      this.$set(this.formData, 'yReverse', this.operateProps.extraProperties?.yReverse || 1)
    }
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        sceneId: '',
        name: '',
        code: '',
        x: '',
        y: '',
        height: '',
        angle: '',
        remark: '',
        xReverse: 1,
        yReverse: 1,
      },
      formRules: {
        sceneId: { required: true, message: '请选择场景', trigger: 'change' },
        name: { required: true, message: '请输入区域名称', trigger: 'blur' },
        code: { required: true, message: '请输入区域编码', trigger: 'blur' },
        x: [
          { required: true, message: '请输入区域偏移X', trigger: 'blur' },
          {
            type: 'number',
            message: '请输入合法数字',
            trigger: 'blur',
            transform: (value) => {
              return Number(value)
            },
          },
        ],
        y: [
          { required: true, message: '请输入区域偏移Y', trigger: 'blur' },
          {
            type: 'number',
            message: '请输入合法数字',
            trigger: 'blur',
            transform: (value) => {
              return Number(value)
            },
          },
        ],
        height: [
          { required: true, message: '请输入区域高度', trigger: 'blur' },
          {
            type: 'number',
            message: '请输入合法数字',
            trigger: 'blur',
            transform: (value) => {
              return Number(value)
            },
          },
        ],
        angle: [
          { required: true, message: '请输入偏移角度', trigger: 'blur' },
          {
            type: 'number',
            message: '请输入合法数字',
            trigger: 'blur',
            transform: (value) => {
              return Number(value)
            },
          },
        ],
      },
    }
  },
  computed: {
    titleType() {
      switch (this.operateType) {
        case 'create':
          return '新增'
        case 'update':
          return '编辑'
        default:
          return '查看'
      }
    },
    isCheck() {
      return this.operateType === 'check'
    },
  },
  methods: {
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        this.saveLoading = true
        if (valid) {
          const params = _.cloneDeep(this.formData)
          delete params.xReverse
          delete params.yReverse
          this.$set(params, 'extraProperties', {
            xReverse: this.formData.xReverse,
            yReverse: this.formData.yReverse,
          })
          if (isEmpty(this.operateProps)) {
            const [err, res] = await implementAreaApi.create({
              body: params,
            })
            if (!err && !isEmpty(res)) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refresh')
              this.$emit('update:visible', false)
            }
          } else {
            const [err, res] = await implementAreaApi.update(this.formData.id, {
              body: params,
            })
            if (!err && !isEmpty(res)) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refresh')
              this.$emit('update:visible', false)
            }
          }
        }
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
